// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon--Icon-module_icon-Gpyvw","svg":"Icon--Icon-module_svg-1UrUX"};